import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Label, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';
import { setCurrencyFormat } from '../../../../utils/helpers';

const LifeTimeValueChart = ({ dir, height, dataToPlot, index }) => {
    const thisMonthData = {};
    console.log(dataToPlot)
    return (
        
        <ResponsiveContainer width="100%" height={height}>
            <LineChart
                width={500}
                height={300}
                data={dataToPlot}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="OrderAt" reversed={dir === 'rtl'} >
                {/* <Label  value="dsfdsf"
                position='insideLeft' style={{ textAnchor: 'middle' }} /> */}
               </XAxis>
                <YAxis type="number" 
                tickFormatter={value => setCurrencyFormat(Number(value).toFixed(2), true)}
                width={90}
                allowDataOverflow >
                <Label angle={-90} value=""
                position='insideLeft' style={{ textAnchor: 'middle' }} />
                </YAxis>
                <Tooltip formatter={value => setCurrencyFormat(Number(value).toFixed(2), true)}
                                />
                <Legend />
                <Line dot={false} type="monotone" dataKey={'firstOrder'.toString()} 
                stroke='#0080ff' strokeWidth={2} />    
            </LineChart>
        </ResponsiveContainer>
    )
}

LifeTimeValueChart.propTypes = {
    dir: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    dataToPlot: PropTypes.arrayOf({}).isRequired,
    index: PropTypes.number,
    // eslint-disable-next-line react/forbid-prop-types
};

LifeTimeValueChart.defaultProps = {
    index: 0
  }

export default React.memo(LifeTimeValueChart);